<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field class="has-text-default">
          <span class="is-italic">
            {{ $t('detailFournisseurSupport.infoBancaire.libelleBanque') }}
          </span>
          <span class="has-text-weight-semibold mgl-10px">
            {{ fournisseurSupport.rib.banque }}
          </span>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field class="has-text-default">
          <span class="is-italic">
            {{ $t('detailFournisseurSupport.infoBancaire.titulaire') }}
          </span>
          <span class="has-text-default has-text-weight-semibold mgl-10px">
            {{ fournisseurSupport.rib.titulaire }}
          </span>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field class="has-text-default">
          <span class="is-italic"> {{ $t('detailFournisseurSupport.infoBancaire.iban') }}</span>
          <span class="has-text-default has-text-weight-semibold mgl-10px">
            {{ iban }}
          </span>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field class="has-text-default">
          <span class="is-italic"> {{ $t('detailFournisseurSupport.infoBancaire.bic') }}</span>
          <span class="has-text-default has-text-weight-semibold mgl-10px">
            {{ fournisseurSupport.rib.bic }}
          </span>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field class="has-text-default">
          <span class="is-italic">
            {{ $t('detailFournisseurSupport.infoBancaire.modePaiement') }}
          </span>
          <span class="has-text-default has-text-weight-semibold mgl-10px">
            {{ modeReglement }}
          </span>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field class="has-text-default">
          <span class="is-italic">
            {{ $t('detailFournisseurSupport.infoBancaire.ordreCheque') }}
          </span>
          <span class="has-text-default has-text-weight-semibold mgl-10px">
            {{ fournisseurSupport.ordreCheque }}
          </span>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import ibanFormater from '@/services/general/ibanFormater';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    fournisseurSupport: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    iban() {
      return ibanFormater(this.fournisseurSupport.rib.iban);
    },
    modeReglement() {
      const modeReglementFind = this.parametre(
        PARAMETRES_KEYS.modeReglement,
      ).find((modeReglement) => {
        return this.fournisseurSupport.modeReglementId === modeReglement.id;
      });
      return modeReglementFind ? modeReglementFind.libelle : null;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
